/**
 * Supabase domain helpers for Client Components.
 *
 * - Client writes: `saveTarotReading` / `recordShare` from this file
 * - Public share reads: `@/lib/supabase/public`
 * - Auth/session on server: `@/lib/supabase/server` + `@/utils/supabase/*`
 */
export type { TarotReading } from './supabase/types';
export { saveTarotReading, recordShare } from './supabase/browser';
